import React, { useEffect, useState }  from 'react';
import styled from 'styled-components';
import { IconChevronBulk } from '../../../Assets/panels/IconChevronBulk';
import { GetDataPromise } from '../../Functions/SendingData';
import { apiMain } from '../../../App';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Checkbox, FormControlLabel, Switch } from '@mui/material';
import { Dictionery } from '../../../Data/Dictionery';
import { styled as styledMui } from '@mui/material/styles';

const Styles = styled.div`
    width: 100%;
    height: min-content;
    position: sticky;
    top: 80px;
    .box-design {
      flex-grow: 1;
      width: calc(100% - 2rem);
      height: min-content;
      margin: 1px;
      padding: 1rem;
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      border-radius: var(--border-radius-3);
      background-color: var(--n-grey-0);
      text-decoration: none;
      color: inherit;
      box-shadow: 0px 23px 40px -13px #00000014;
      position: relative;
      /* position: sticky; */
      /* top: 80px; */
      &::before {
          content: "";
          z-index: -1;
          position: absolute;
          inset: -1px;
          background: linear-gradient(180deg, #E5E5E5 0%, #E5E5E500 100%);
          border-radius: calc(var(--border-radius-3) + 1px);
      }
      .line-h {
        height: 1px;
        background-color: var(--n-grey-1);
      }
      .filter {
        transition: var(--trans-2);
        max-height: 400px;
        &.closed {
          max-height: 60px;
          .filter-container {
            max-height: 0;
          }
          .top {
            .icon {
              svg {
                transform: rotate(180deg);
              }
            }
          }
        }
        .top {
          cursor: pointer;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .circle {
            width: 8px;
            height: 8px;
            border-radius: 100px;
            background-color: var(--n-grey-11);
          }
          .title {
            display: flex;
            align-items: center;
            gap: 8px;
            font-size: 14px;
            font-weight: 700;
          }
          .icon {
            svg {
              width: 24px;
              height: 24px;
              fill: var(--n-grey-2);
              display: block;
              transition: var(--trans-2);
            }
          }
        }
        .filter-container {
          max-height: 300px;
          transition: var(--trans-2);
          overflow: hidden;
          overflow-y: auto;
          .scroll-container {
            display: grid;
            grid-template-rows: 1fr;
            .filter-item-smal {
              padding: 0 0.5rem;
              display: flex;
              align-items: center;
              min-height: 40px;
            }
          }
        }
      } 
    }
    @media screen and (max-width: 850px) {
      position: relative;
      top: 0px;
    }
`
export default function TourFilter (props){
  const location = useLocation()
  const navigate = useNavigate()
  const {lan, params, data, dataMain} = props;
  const paramsUrl = useParams()

  const [opened, setOpened] = useState({})
  const [country, setCountry] = useState([])
  const [city, setCity] = useState([])
  useEffect(() => {
    getData();
  }, []);
  useEffect(() => {
    getData();
  }, [params, data])
  const getData = async (force = false) => {
    let URLparams = new URLSearchParams();
    if(data.Continent_Id){
      URLparams.append("Continent_Id", data.Continent_Id);
      GetDataPromise(`${apiMain}/api/v1/setting/country/select_country?${URLparams.toString()}`, force)
      .then((res) => {
        let parsed = JSON.parse(res);
        if((parsed.status && parsed.status !== "error" && parsed.status !== "error-no-internet") || parsed.status === "success"){
          setCountry(parsed.data);
        }
      });
    }
    let countryID = params.Country_Id;
    if(dataMain.Country && dataMain.Country.Country_Url === paramsUrl.country){
      countryID = dataMain.Country.Country_Id
    }
    if(countryID){
      URLparams.append("Country_Id", countryID);
      GetDataPromise(`${apiMain}/api/v1/setting/city/select?${URLparams.toString()}`, force)
        .then((res) => {
          let parsed = JSON.parse(res);
          if((parsed.status && parsed.status !== "error" && parsed.status !== "error-no-internet") || parsed.status === "success"){
            setCity(parsed.data);
          }
        });
    }
  }
  const changeValues = (values, newValue)=> {
    let valuesList = values.split(",");
    if(values === ""){
      valuesList = []
    }
    let find = valuesList.findIndex((v) => v === newValue);
    if(find !== -1){
      valuesList.splice(find, 1)
    } else {
      valuesList.push(newValue)
    }
    return valuesList.join(",")
  }
  const onChange = (e) => {
    const [name, value] = e.target.name.split("-");
    let temp = {...params};
    temp[name] = changeValues((temp[name]) ? temp[name] : "", value)
    if(temp[name] === ""){
      delete temp[name];
    }
    let uparams = new URLSearchParams();
    if(Object.keys(temp).length){
      let keys = Object.keys(temp);
      for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        uparams.append(key, temp[key])
      }
    }
    navigate(`${location.pathname}?${uparams.toString()}`)
  }
  const makeData = (v) => {
    let valuesList;
    switch(v.type){
      case "country": 
        valuesList = [];
        if(params.Country_Id){
          valuesList = params.Country_Id.split(",");
        }
        if(params.Country_Id === ""){
          valuesList = []
        }
        return country.map((vv, ii) => {
          return (
            <div className='filter-item-smal' key={ii}>
              <FormControlLabel 
                control={
                  <Checkbox 
                    name={"Country_Id-"+vv.Country_Id} 
                    checked={valuesList.findIndex(value => parseInt(value) === vv.Country_Id) !== -1} 
                    onChange={onChange}
                  />} 
                label={(lan.filename === "fa") ? vv.Country_Name : vv.Country_En_Name}
              />
              
            </div>
          )
        });
      case "city": 
        valuesList = [];
        if(params.City_Id){
          valuesList = params.City_Id.split(",");
        }
        if(params.City_Id === ""){
          valuesList = []
        }
        return city.map((vv, ii) => {
          return (
            <div className='filter-item-smal' key={ii}>
              <FormControlLabel 
                control={
                  <Checkbox 
                    name={"City_Id-"+vv.City_Id} 
                    checked={valuesList.findIndex(value => parseInt(value) === vv.City_Id) !== -1} 
                    onChange={onChange}
                  />} 
                label={(lan.filename === "fa") ? vv.City_Name : vv.City_EnName}
              />
            </div>
          )
        })
      case "archived":
        // Is_Archive
        let active = false;
        if(params.Is_Archive && params.Is_Archive === "1"){
          active = true;
        }
        return (
          <div className='filter-item-smal' key={"archive"}>
              <label htmlFor={"Is_Archive-"+1}>
                {Dictionery.show[lan.filename]}
              </label>
              <div style={{flexGrow: "1"}}></div>
              <IOSSwitch
                sx={{
                  m: "0 -0.5rem 0 0",
                }}
                id={"Is_Archive-"+1}
                name={"Is_Archive-"+1}
                checked={active} 
                onChange={onChange}
              />
            </div>
        )
      default:
        return;
    }
  }
  const makeFilter = (v, i) => {
    return (
      <>
      {
        (i !== 0) ? (
          <div className='line-h'></div>
        ) : ""
      }
      <div className={'filter' + ((opened[i]) ? " open" : " closed")} key={i}>
        <div className='top' onClick={() => {
          setOpened((prev) => {
            let temp = {...prev};
            temp[i] = !(temp[i]);
            return temp
          })
        }}>
          <div className='title'>
            <div className='circle'></div>
            {v.name[lan.filename]}
          </div>
          <div className={'icon'}>
            <IconChevronBulk/>
          </div>
        </div>
        <div className='filter-container'>
          <div className='scroll-container'>
            {makeData(v)}
          </div>
        </div>
      </div>
      </>
    )
  }
  const makeFilters = () => {
    let filtered = filterTypes.filter((v) => {
      if(v.type === "country"){
        if(dataMain.Country && Object.keys(dataMain.Country).length && dataMain.Country.Country_Url === paramsUrl.country){
          return false
        }
      }
      if(v.type === "city"){
        if(city.length === 0){
          return false;
        }
      }
      return true
    })
    
    return filtered.map((v, i) => {
      return makeFilter(v, i)
    })
  }
  return (
    <Styles>
      <div className='box-design'>
        {makeFilters()}
      </div>
    </Styles>
  )
}


const filterTypes = [
  {
    type: "archived",
    name: {
      "fa": "آرشیو شده ها",
      "en": "Archived",
    },
  },
  {
    type: "country",
    name: {
      "fa": "کشور ها",
      "en": "country",
    },
  },
  {
    type: "city",
    name: {
      "fa": "شهر ها",
      "en": "city",
    },
  },
]





const IOSSwitch = styledMui((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: '#65C466',
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: theme.palette.grey[100],
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: 0.7,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 22,
    height: 22,
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: '#E9E9EA',
    opacity: 1,
    transition: 'background-color ease-in-out 0.3s',
  },
}));